module.exports = __webpack_public_path__ + "img/t2-c10.f6d71b7f.png";